import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Popover} from "@material-ui/core";
import TextField from "@material-ui/core/TextField/TextField";
import MaterialUISelect from "../../../common/selects/MaterialUISelect";
import ActionPopover from "../../../common/popovers/ActionPopover";
import DatePicker from "../../../common/pickers/DatePicker";
import {isNumberStringWithTwoDecimalPlaces} from "../../../../utils/validationUtils";
import {toNumber} from "../../../../utils/formatUtils";
import {loadNdsItems, saveOrUpdateNdsItem} from "../../../../actions/ndsActions";
import {addTimezoneOffset} from "../../../../utils/dateUtils";

export default function NdsToolsPopover({button, item}) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const dispatch = useDispatch();
    const countries = useSelector(state => state.countriesReducer.countries);

    const [editableNdsItem, setEditableNdsItem] = useState({});
    const [selectedCountry, setSelectedCountry] = useState(null);


    useEffect(() => {
        if (!item || !anchorEl) {
            return;
        }
        setEditableNdsItem({...item});
    }, [item, anchorEl]);

    useEffect(() => {
        if (!item || !countries || countries.length === 0) {
            return;
        }
        const country = countries.find(country => country.id === item.countryId);
        setSelectedCountry(country);

    }, [item, countries])


    const handleClick = (e) => {
        setAnchorEl(e.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const setNdsValue = (e) => {
        let value = e.target.value;
        value = value.replace(/\s/g, "");
        if (!isNumberStringWithTwoDecimalPlaces(value)) {
            return;
        }
        setEditableNdsItem({...editableNdsItem, value: toNumber(value)});
    }

    const setDate = (date) => {
        setEditableNdsItem({...editableNdsItem, fromDate : date.getTime()})
    }

    const setCountry = (country) => {
        setSelectedCountry(country);
        setEditableNdsItem({...editableNdsItem, countryId : country.id, countryName : country.name})
    }

    const saveNdsItem = () => {
        dispatch(saveOrUpdateNdsItem({...editableNdsItem, fromDate: addTimezoneOffset(new Date(editableNdsItem.fromDate))}, () => dispatch(loadNdsItems())));
        handleClose();
    };


    const popover = () => {
        return (
            <Popover id={id}
                     open={open}
                     anchorEl={anchorEl}
                     onClose={handleClose}
                     anchorOrigin={{
                         vertical: 'bottom',
                         horizontal: 'right',
                     }}
                     transformOrigin={{
                         vertical: 'top',
                         horizontal: 'right',
                     }}
            >
                <div style={{padding: "10px", textAlign: "center"}}>
                    {item?.id ? "Редактировать ставку" : "Создать ставку"}
                </div>
                <div style={{padding: "10px", minWidth: "350px", maxWidth: "500px", maxHeight: "90vh", overflowY: "auto"}}>
                    <div className="col" style={{padding: "0 10px 0 0"}}>
                        <DatePicker
                            inputLabel="Дата начала действия"
                            date={editableNdsItem?.fromDate && new Date(editableNdsItem.fromDate)}
                                    autoClose
                                    onSelectDate={setDate}/>
                    </div>
                    <MaterialUISelect
                        dropdownData={countries}
                        selectedValue={selectedCountry}
                        displayedFields={["id", "name"]}
                        dataField='id'
                        label='Страна'
                        onSelectCallbackFunction={setCountry}
                        isSearchable/>

                    <TextField label="Ставка НДС, %"
                               name="value"
                               value={editableNdsItem?.value || ""}
                               InputLabelProps={{shrink: true}}
                               style={{width: '100%', paddingBottom: '15px'}}
                               onChange={setNdsValue}
                    />
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <div style={{width: "100%"}}>
                        <div className="circle-btn-group" >
                            <ActionPopover
                                button={<button className="circle-btn" title="Сохранить ставку НДС"><i className="ti ti-save"/></button>}
                                popoverLocation='top'
                                label={"Сохранить ставку НДС?"}
                                handleSubmit={saveNdsItem}
                            />

                            <button className="circle-btn" title="Отменить"><i className="ti ti-close" onClick={handleClose}/>
                            </button>
                        </div>
                    </div>
                </div>
            </Popover>
        )
    };

    return (
        <>
            <div className="" onClick={handleClick}>
                {button}
            </div>
            {anchorEl && popover()}
        </>
    );}